<div class="m-1">
  <form
    id="b9b51433-5da3-4ee3-af2c-00d7ca9a41f0"
    class="bg-light p-2 rounded"
    [formGroup]="form"
    (ngSubmit)="submitFilter()">
    <div class="p-2">
      <div class="row justify-content-center justify-content-sm-between m-0 gx-2 gy-2 gy-sm-0">
        <div class="col-auto order-last order-sm-first"></div>
        <div class="col-12 col-sm-10 col-dm-8 col-lg-8 col-xl-8 col-xxl-5 p-0 m-0">
          <div class="row search-shadow rounded p-0 m-0 align-items-stretch flex-nowrap bg-white">
            <div class="col-auto p-2 px-3">
              <label for="searchText">
                <i class="fa fa-search small text-500"></i>
              </label>
            </div>
            <div class="col-6 p-0 d-block flex-fill">
              <input
                type="text"
                id="searchText"
                class="form-control form-control-lg search-input h-100 rounded-end-0 border-0 shadow-none fs-6 px-0 fw-lighter"
                placeholder="Search rental agreements..."
                formControlName="searchText" />
            </div>
            @if (form.controls.searchText.value) {
              <button type="button" class="btn col-auto m-0 px-3 border-0" (click)="form.controls.searchText.reset()">
                <i class="fa fa-times text-500"></i>
              </button>
            }
            <div class="col-4 p-0">
              <p-select
                [options]="[
                  { label: 'By Rental Agreement Number', value: 'rentalAgreementNumber' },
                  { label: 'By Reservation Number', value: 'reservationNumber' },
                  { label: 'By Reference', value: 'reference' }
                ]"
                optionLabel="label"
                optionValue="value"
                formControlName="predicate"
                [fluid]="true"
                class="search-predicate">
              </p-select>
            </div>
            @if (!advancedFilter) {
              <button
                @searchBtnAnimation
                type="button"
                form="7c0a5fe8-b8a8-42e8-b346-52b6beb38701"
                class="btn btn-success col-2 m-0 p-0 rounded-start-0"
                (click)="submitSearch()">
                Search
              </button>
            }
          </div>
        </div>
        @if (!advancedFilter) {
          <div class="col-auto p-0">
            <button type="button" class="btn" (click)="expandFilter()">
              <i class="fa fa-filter fa-fw text-secondary m-auto"></i>
            </button>
          </div>
        } @else {
          <div class="col-auto p-0">
            <button type="button" class="btn" (click)="collapseFilter()">
              <i class="fa fa-chevron-up text-secondary m-auto"></i>
            </button>
          </div>
        }
      </div>
    </div>
    @if (advancedFilter) {
      <div @advancedFilterAnimation>
        <div class="row g-1 mx-1 pt-3">
          <div class="col-12 col-xl-8">
            <div class="small fw-semibold">Rental Agreement</div>
            <div class="row align-items-start g-1 px-2 pb-2 m-0">
              <div class="col-12 col-md-4">
                <p-iftalabel>
                  <p-autocomplete
                    appBrokerAutocomplete
                    formControlName="clientId"
                    optionLabel="selectedLabel"
                    [forceSelection]="true"
                    [showClear]="true"
                    (onClear)="submitFilter()"
                    inputId="brokerClientId">
                    <ng-template let-broker #item>
                      <div [innerHTML]="broker.optionLabel"></div>
                    </ng-template>
                  </p-autocomplete>
                  <label for="brokerClientId">Broker</label>
                </p-iftalabel>
              </div>
              <div class="col-12 col-md-4">
                <p-iftalabel>
                  <p-datepicker
                    dateFormat="dd/mm/yy"
                    placeholder="from date - to date"
                    pInputMask="99/99/9999"
                    formControlName="creationDateRange"
                    selectionMode="range"
                    inputId="creationDateRange"
                    showIcon
                    class="d-block"
                    [maxDate]="now"
                    (onClearClick)="submitFilter()"
                    [showButtonBar]="true"
                    iconDisplay="input">
                  </p-datepicker>
                  <label for="creationDateRange">Creation Date Range</label>
                </p-iftalabel>
              </div>
              <div class="col-12 col-md-4">
                <p-iftalabel class="w-100">
                  <p-multiselect
                    inputId="ms_cities"
                    [options]="getStatusesOptions()"
                    optionLabel="label"
                    optionValue="value"
                    filter="false"
                    showClear="true"
                    formControlName="statuses"
                    [maxSelectedLabels]="3"
                    (onClear)="submitFilter()"
                    styleClass="w-100" />
                  <label for="ms_cities">Statuses</label>
                </p-iftalabel>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4">
            <div class="small fw-semibold">Main Driver</div>
            <div class="row align-items-start g-1 px-2 pb-2 m-0">
              <div class="col-12 col-md-6">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control validated"
                    id="driverFirstName"
                    formControlName="driverFirstName" />
                  <label for="driverFirstName">First Name</label>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control validated"
                    id="driverLastName"
                    formControlName="driverLastName" />
                  <label for="driverLastName">Last Name</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center g-1 justify-content-between m-1">
          <div class="small fw-semibold">Locations</div>
          <div class="col row align-items-start g-1 bg-light rounded px-2 pb-2 border m-0">
            <div class="col-12">
              <div class="small text-muted">
                <i class="fa fa-location-dot fa-fw text-primary"></i>
                Out
              </div>
            </div>
            <div class="col-7">
              <p-iftalabel>
                <p-multiselect
                  appLocationMultiselect
                  #pickupLocationsMS="locationMultiselectInstance"
                  [inputId]="'pickupLocations'"
                  [autofocusFilter]="true"
                  [onlyUserCountry]="true"
                  [group]="true"
                  placeholder="Select Locations"
                  filterPlaceHolder="Type to search..."
                  optionLabel="code"
                  scrollHeight="300px"
                  filter="true"
                  filterBy="optionLabel,countryName"
                  virtualScroll="true"
                  virtualScrollItemSize="40"
                  [maxSelectedLabels]="4"
                  display="comma"
                  showClear="true"
                  [dataKey]="'code'"
                  showToggleAll="false"
                  formControlName="pickupLocations"
                  (onClear)="submitFilter()"
                  fluid="true">
                  <ng-template let-location #item>
                    <div class="ps-2 fw-normal" [innerHTML]="location.optionLabel"></div>
                  </ng-template>
                  <ng-template let-group #group>
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <span class="flag-icon" [class]="group.flagIcon"></span>
                        <span class="ms-2" [innerHTML]="group.countryName"></span>
                      </div>
                      <p-button
                        label="Select"
                        variant="text"
                        size="small"
                        (onClick)="pickupLocationsMS.selectCountry(group.countryCode)" />
                    </div>
                  </ng-template>
                </p-multiselect>
                <label for="pickupLocations">Locations</label>
              </p-iftalabel>
            </div>
            <div class="col-5">
              <p-iftalabel>
                <p-datepicker
                  placeholder="from date - to date"
                  pInputMask="99/99/9999"
                  formControlName="dateOutRange"
                  selectionMode="range"
                  inputId="dateOutRange"
                  showIcon
                  class="d-block"
                  (onClearClick)="submitFilter()"
                  [showButtonBar]="true"
                  iconDisplay="input" />
                <label for="dateOutRange">Date Range</label>
              </p-iftalabel>
            </div>
          </div>
          <div class="col-12 d-md-none text-center"><i class="fa fa-down-long fa-fw"></i></div>
          <div class="col-auto d-none d-md-block"><i class="fa fa-right-long fa-fw"></i></div>
          <div class="col row align-items-start g-1 bg-light rounded px-2 pb-2 border m-0">
            <div class="col-12">
              <div class="small text-muted">
                <i class="fa fa-location-dot fa-fw text-primary"></i>
                Return
              </div>
            </div>
            <div class="col-7">
              <p-iftalabel>
                <p-multiselect
                  appLocationMultiselect
                  #dropOffLocationsMS="locationMultiselectInstance"
                  [onlyUserCountry]="true"
                  [autofocusFilter]="true"
                  [inputId]="'dropOffLocations'"
                  [group]="true"
                  placeholder="Select Locations"
                  filterPlaceHolder="Type to search..."
                  optionLabel="code"
                  scrollHeight="300px"
                  filter="true"
                  filterBy="optionLabel,countryName"
                  [dataKey]="'code'"
                  virtualScroll="true"
                  virtualScrollItemSize="40"
                  [maxSelectedLabels]="4"
                  display="comma"
                  showClear="true"
                  showToggleAll="false"
                  formControlName="dropOffLocations"
                  (onClear)="submitFilter()"
                  fluid="true">
                  <ng-template let-location #item>
                    <div class="ps-2 fw-normal" [innerHTML]="location.optionLabel"></div>
                  </ng-template>
                  <ng-template let-group #group>
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <span class="flag-icon" [class]="group.flagIcon"></span>
                        <span class="ms-2" [innerHTML]="group.countryName"></span>
                      </div>
                      <p-button
                        label="Select"
                        variant="text"
                        size="small"
                        (onClick)="dropOffLocationsMS.selectCountry(group.countryCode)" />
                    </div>
                  </ng-template>
                </p-multiselect>
                <label for="dropOffLocations">Locations</label>
              </p-iftalabel>
            </div>
            <div class="col-5">
              <p-iftalabel>
                <p-datepicker
                  formControlName="dateInRange"
                  placeholder="from date - to date"
                  pInputMask="99/99/9999"
                  selectionMode="range"
                  inputId="dateInRange"
                  showIcon
                  class="d-block"
                  (onClearClick)="submitFilter()"
                  [showButtonBar]="true"
                  iconDisplay="input" />
                <label for="dateInRange">Date Range</label>
              </p-iftalabel>
            </div>
          </div>
        </div>
        <div class="row g-1 m-1 justify-content-end p-0">
          <button type="button" class="btn btn-light col-auto" (click)="reset()" [disabled]="!form.dirty">
            <div class="d-flex justify-content-center align-items-center gap-2">
              <div>Clear All</div>
            </div>
          </button>
          <button
            type="submit"
            form="b9b51433-5da3-4ee3-af2c-00d7ca9a41f0"
            class="btn btn-success col-auto ms-2 px-5"
            [disabled]="!form.dirty || !form.valid">
            <div class="d-flex justify-content-center align-items-center gap-2">
              <div>Filter</div>
            </div>
          </button>
        </div>
      </div>
    }
  </form>
</div>
